import { useMemo } from 'react';
import './Returns.scss';
import ProFormaReturnsTable from 'components/ProFormaReturnsTable/ProFormaReturnsTable';
import RenderIf from 'components/RenderIf/RenderIf';
import { isEmpty } from 'lodash';
import useHasBuilderDepositSource from 'hooks/useHasBuilderDepositSource';
import { getNonEquityNonDebtSourceLabel } from 'utils/sourceTypeUtils';
import { getSaleIndexForCadence } from 'views/ProFormaTable/helpers';
import { useProFormaSocketContext } from '../../ProForma/socketContext/ProFormaSocketProvider';
import { getPeriodKeys, transformReturnsData } from './helpers';
import { ProFormaModelIds } from 'constants/proForma';

const Returns = () => {
    const {
        returnsData, operatingInfo, showCents, periodCadence, proForma, sources, sourceTypes,
    } = useProFormaSocketContext();

    const saleMonth = operatingInfo.saleMonth ?? proForma?.saleMonth ?? undefined;
    const saleIndex = getSaleIndexForCadence(saleMonth, periodCadence);

    const transformedData = useMemo(() => transformReturnsData(returnsData, periodCadence), [returnsData, periodCadence]);
    const dateKeys = useMemo(() => getPeriodKeys(returnsData, periodCadence, saleIndex), [returnsData, periodCadence, saleIndex]);
    const hasBuilderDepositSource = useHasBuilderDepositSource(sources, sourceTypes);
    const nonEquityNonDebtSourceLabel = useMemo(
        () => getNonEquityNonDebtSourceLabel(sources?.sources, sourceTypes),
        [sources, sourceTypes],
    );

    return (
        <RenderIf isTrue={!isEmpty(proForma)} isLoading={isEmpty(proForma)}>
            <div className="Returns">
                {transformedData && (
                    <ProFormaReturnsTable
                        showCents={showCents}
                        propertyReturns={transformedData}
                        dateKeys={dateKeys}
                        operationBeginMonth={operatingInfo.operationBeginMonth || 0}
                        cadence={periodCadence}
                        isLandDevelopment={proForma?.proFormaModelId === ProFormaModelIds.LAND_DEVELOPMENT}
                        hasBuilderDepositSource={hasBuilderDepositSource}
                        nonEquityNonDebtSourceLabel={nonEquityNonDebtSourceLabel}
                    />
                )}
            </div>
        </RenderIf>
    );
};

export default Returns;
